import React from 'react';
import { cn } from '../lib/utils';

export default function TrustStamp({ text, className, dark = false }) {
  if (!text) return null;

  // Split on pipe (|) separator if present
  const parts = typeof text === 'string' ? text.split(/\s*\|\s*/) : [String(text)];

  const highlightNames = [
    'Felix Enghoff Klich',
    'Felix Klich',
    'Martin Bergholtz'
  ];

  return (
    <div
      className={cn(
        "mt-8 sm:mt-10 lg:mt-12 text-xs tracking-normal flex flex-wrap items-center gap-x-2 gap-y-1 font-sans",
        dark ? "text-white/75" : "text-[#566964]",
        className
      )}
    >
      {parts.map((part, idx) => {
        // Find if this segment contains one of our known clinician names
        const matchedName = highlightNames.find((name) => part.includes(name));

        return (
          <span key={idx} className="inline-flex items-center gap-2">
            {idx > 0 && (
              <span className="opacity-40 select-none" aria-hidden="true">
                |
              </span>
            )}
            <span className="leading-relaxed">
              {matchedName ? (
                <>
                  {part.split(matchedName)[0]}
                  <strong className={cn("font-semibold", dark ? "text-white" : "text-petrol-dark")}>
                    {matchedName}
                  </strong>
                  {part.split(matchedName)[1]}
                </>
              ) : (
                part
              )}
            </span>
          </span>
        );
      })}
    </div>
  );
}
